import React from 'react';
import Paper from '@mui/material/Paper';
import {
  Box,
  Grid,
  useTheme,
  useMediaQuery,
  Divider,
  Table,
} from '@mui/material';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TABLET_BREAKPOINT } from '../../Constants/constant';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import SchoolIcon from '@mui/icons-material/School';
import CardMedia from '@mui/material/CardMedia';
import CallIcon from '@mui/icons-material/Call';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import './App.css';
import ApplicationCard from '../../Cards/ApplicationCard';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const accord = {
  text1: 'personal Document(04)',
  icon1: <ErrorOutlineIcon style={{ color: 'green' }} />,
  text2: 'Academic Details(02)',
  icon2: <PeopleOutlineIcon style={{ color: 'red' }} />,
};

function createData(name, icon) {
  return { name, icon };
}

const rows = [
  createData(accord.text1, accord.icon1),
  createData(accord.text2, accord.icon2),
];

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '1061px',
    maxHeight: '136px',
  },
  name: {
    fontWeight: 500,
    fontSize: '32px',
    color: '#061938',
    textAlign: 'left',
  },
  wrapIcon: {
    alignItems: 'center',
    display: 'flex',
    fontWeight: 500,
    fontSize: '16px',
    color: '#092682',
  },
  content: {
    fontWeight: 500,
    fontSize: '16px',
  },
  image: {
    borderRadius: '50%',
    position: 'absolute',
    maxWidth: '165px',
    maxHeight: '165px',
    width: 'auto',
    height: '165px',
  },
  Cfooter: {
    fontWeight: 400,

    color: 'white',
    fontSize: '14px',
  },
  content1: {
    textAlign: 'left',
    fontWeight: 500,
    fontSize: '18px',
  },
  accordian: {
    justifyContent: 'space-between',
  },
  Accordtitle: {
    fontWeight: 400,
    fontSize: '16px',
    color: '#061938',
  },
  Abox: {
    background: '#FCFCFC',
  },
  alignIcon: {
    display: 'flex',
  },
  footContent: {
    color: 'white',
    display: 'flex',
    fontSize: '14px',
    fontWeight: 400,
  },
  MobileCardimage: {
    height: '100px',
    width: '100px',
    borderRadius: '50px',
    Display: 'flex',
    alignItems: 'center',
  },
  mobileName: {
    fontWeight: 500,
    fontSize: '20px',
    color: '#061938',
    textAlign: 'left',
  },
}));
const cardData = [
  {
    programName: 'Bachelor of Buisness Administartion',
    departmentName: 'Finance',
    applicationNumber: '7878978',
    courseDuration: '4',
    courseBatch: 'Manipal, Udipi',
    endDate: '20 April 2022',
    applicationStatus: 19,
  },
  {
    programName: 'Bachelor of Technology',
    departmentName: 'Finance',
    applicationNumber: '7878978',
    courseDuration: '4',
    courseBatch: 'Manipal, Udipi',
    endDate: '20 April 2022',
    applicationStatus: 19,
  },
  {
    programName: 'Bachelor of Technology',
    departmentName: 'Finance',
    applicationNumber: '7878978',
    courseDuration: '4',
    courseBatch: 'Manipal, Udipi',
    endDate: '20 April 2022',
    applicationStatus: 19,
  },
];

export default function ProfileDetails(props) {
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(TABLET_BREAKPOINT)
  );
  function sendEmail(params) {
    window.open('mailto:support@example.com?subject=SendMail&body=Description');
  }
  return (
    <React.Fragment>
      {isMobileScreen ? (
        <Card
          sx={{ width: '100%', borderRadius: '16px', height: 'fitContent' }}
        >
          <CardContent>
            <Grid container spacing={2}>
              <Box sx={{ mt: 3, pl: 2 }}>
                <Grid item xs={5}>
                  <CardMedia
                    className={classes.MobileCardimage}
                    component="img"
                    image="data:image/jpeg;base64,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"
                    alt="green iguana"
                  />
                </Grid>
              </Box>
              <Grid item xs={7}>
                <Box sx={{ mt: 2, pb: 4 }}>
                  <Typography className={classes.mobileName}>
                    Monika Sharma
                  </Typography>
                  <Typography style={{ textAlign: 'left' }}>
                    &nbsp;Applying For : &nbsp; <br />
                    <span className={classes.wrapIcon}>
                      <SchoolIcon />
                      &nbsp; Undergraduate
                    </span>
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
          <CardActions
            style={{ marginTop: '-20px', backgroundColor: '#092682' }}
          >
            <Grid
              container
              style={{ background: '#092682', padding: '8px', color: 'white' }}
            >
              <Grid item xs={12} className={classes.alignIcon}>
                <MailOutlineRoundedIcon
                  onClick={() => {
                    window.open(
                      'mailto:Manika.sharma@gmail.com?subject=SendMail&body=Description'
                    );
                  }}
                />
                <Typography>Manika.sharma@gmail.com </Typography>
              </Grid>
              <Grid item xs={12} sx={{ mt: 1 }} className={classes.alignIcon}>
                <WhatsAppIcon />
                <Typography>91-9899567849 </Typography>
              </Grid>
              <Grid item xs={6} sx={{ mt: 1 }} className={classes.alignIcon}>
                <CallIcon />
                <Typography> 0124-4117924</Typography>
              </Grid>
              <Grid item xs={6} sx={{ mt: 1 }} className={classes.alignIcon}>
                <LocationOnIcon />
                <Typography>Kolkata</Typography>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      ) : (
        <Card sx={{ Width: '100%', borderRadius: '16px' }}>
          <CardContent style={{ minheight: '136px' }}>
            <Grid container spacing={10}>
              <Grid item md={2} lg={2}>
                <CardMedia
                  className={classes.image}
                  component="img"
                  image="data:image/jpeg;base64,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"
                  alt="green iguana"
                />
              </Grid>
              <Grid item md={10}>
                <Typography className={classes.name}>Monika Sharma</Typography>
                <Typography>
                  <Grid container spacing={2}>
                    <Grid item className={classes.content}>
                      {' '}
                      Applying For :
                    </Grid>
                    <Grid item className={classes.wrapIcon}>
                      <SchoolIcon />
                      &nbsp; Undergraduate
                    </Grid>
                  </Grid>
                </Typography>
              </Grid>
            </Grid>
            <br />
          </CardContent>
          <CardActions style={{ background: '#092682', height: '70px' }}>
            <Grid container spacing={10}>
              <Grid item xs={2}></Grid>
              <Grid item xs={10} style={{ marginTop: '10px' }}>
                <Typography className={classes.footContent}>
                  <Grid container spacing={1}>
                    <table>
                      <tr>
                        <td>
                          <Grid container spacing={1}>
                            <Grid item>
                              <MailOutlineRoundedIcon
                                onClick={() => {
                                  window.open(
                                    'mailto:Manika.sharma@gmail.com?subject=SendMail&body=Description'
                                  );
                                }}
                              />
                            </Grid>
                            <Grid item sx={{ pl: 2 }}>
                              <Typography>Manika.sharma@gmail.com </Typography>
                            </Grid>
                          </Grid>
                        </td>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <td>
                          <Grid container spacing={1}>
                            <Grid item>
                              <WhatsAppIcon />
                            </Grid>
                            <Grid item>
                              <Typography>91-9899567849 </Typography>
                            </Grid>
                          </Grid>
                        </td>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <td>
                          <Grid container spacing={1}>
                            <Grid item>
                              <CallIcon />
                            </Grid>
                            <Grid item>
                              <Typography> 0124-4117924</Typography>
                            </Grid>
                          </Grid>
                        </td>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <td>
                          <Grid container spacing={1}>
                            <Grid item>
                              <LocationOnIcon />
                            </Grid>
                            <Grid item>
                              <Typography>Kolkata</Typography>
                            </Grid>
                          </Grid>
                        </td>
                      </tr>
                    </table>
                  </Grid>
                </Typography>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      )}
      <Box sx={{ mt: 7, pb: 2 }}>
        <Typography className={classes.content1}>Applied Courses</Typography>
      </Box>
      <Grid
        item
        container
        md={12}
        xs={12}
        sm={12}
        spacing={isMobileScreen ? 3 : 2}
        width={isMobileScreen ? '100%' : undefined}
        marginLeft={isMobileScreen ? '-20px' : undefined}
        paddingBottom={theme.spacing(4)}
        paddingTop={
          isMobileScreen ? `${theme.spacing(4)} !important` : undefined
        }
      >
        {cardData.map((s, i) => {
          return (
            <Grid
              container
              item
              paddingTop={
                isMobileScreen ? `${theme.spacing(2)} !important` : undefined
              }
              xs={12}
              sm={6}
              md={4}
              lg={3}
            >
              <ApplicationCard item={s} colValue={3} />
            </Grid>
          );
        })}
      </Grid>
      <Box
        sx={{ mt: 3, pb: 2 }}
        padding={isMobileScreen ? '0px 16px 16px 16px' : undefined}
      >
        <Typography className={classes.content1}>Documents</Typography>
      </Box>
      <Box sx={{ mt: 2, pb: 2 }}>
        <Box className={classes.Abox}>
          {rows.map((row) => (
            <Accordion style={{ boxShadow: 'none', background: '#FCFCFC' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                className={classes.accordian}
              >
                <Typography
                  className={classes.Accordtitle}
                  textAlign={isMobileScreen ? 'left' : undefined}
                >
                  <li>{row.name}</li>
                </Typography>
                <Box marginTop={isMobileScreen ? undefined : '7px'}>
                  {row.icon}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography></Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
      <br /> <br />
    </React.Fragment>
  );
}
